<template>
<div class="Header">
  <header>テストページ</header>
    <nav>
      <ul>
        <router-link tag="li" id="home-nav" to="/" exact><a>HOME</a></router-link>
        <router-link tag="li" id="game-nav" to="/Main2"><a>ブログ</a></router-link>
        <router-link tag="li" id="game-nav" to="/Main2"><a>当サイト</a></router-link>
      </ul>
    </nav>
    <div class="box" >
    　<img src="static/img/lake.jpg" />
      <div class="text">日本の名所を<br>紹介します</div>
    </div>
</div>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      msg: 'ここはヘッダーです'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
header{
  color: #555d6b;
  font-size: 40px;
  font-weight:bold;
}
nav ul{
  margin:auto;
  padding: 0px;
}
nav li {
  text-align: center;
  color: #666666;
  display: inline-block;
  list-style: none;
  padding:10px;
}
nav li a {
  text-decoration: none;
  color: #666666;
}
img {
  width: 100%;
  height: 50%;
}
.box
{
    position: relative;
}

.box div.text
{
    position: absolute;
    width: 100%;
    left: 0; 
    top: calc(50% - 70px); 
    text-align: center; 
    color: darkblue; 
    font-weight: bold; 
    font-size: 50px;
    color: white;
    font-weight: bold;
    text-shadow: 5px 5px 5px #444444;
    line-height: 90px;
}

@media(max-width:768px) {
.box div.text {
    top: calc(50% - 30px); 
    font-size: 20px;
    line-height: 30px;
}
}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue